import React from "react";
import { GET_STATISTICS_QUERY } from "queries/queries";
import { useQuery } from "@apollo/client";
import CourseProgressItem from "./course-progress-item";

const CoursesProgress = ({  }) => {
  const { loading, error, data } = useQuery(GET_STATISTICS_QUERY, {
    fetchPolicy: "no-cache"
  });

  if (loading) return <p>Loading...</p>;
  if (error) return <p>Error: {error.message}</p>;

const sortedCourses = data.statistics.courseStatistics
  .sort((a, b) => b.progress - a.progress)
  .slice(0, 10);

  return (
    <div className="course-statistics">
      <div className="course-statistics-title">Kurse</div>
        {sortedCourses.map((statistic, index) => (
          <CourseProgressItem 
            key={statistic.courseId} 
            statistic={statistic} 
            index={index}
            length={sortedCourses.length}
          />
        ))}
    </div>
  );
};

export default CoursesProgress;
